var exports = {
  "U": "xae11d333--230bad--arrow",
};

module.exports = exports;
